export const createThunk = (fn) => (dispatch, getState) => {
    fn(dispatch)(getState)
}